<!-- Displays the "ANALYTICS" header and supports multiple tabs based on analysis mode, etc. This would keep `CohortManager.vue` lightweight -->
<template>
  <v-sheet color="white" height="100%" class="rounded-lg shadow pa-0 ma-0">
    <v-container fluid fill-width class="ma-0 pa-0">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <v-card color="#eeeeee" class="pt-1">
            <v-card-title class="primary--text pl-3 py-2"
              >ANALYTICS
              <v-divider vertical class="ml-4 mr-4"> </v-divider>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      v-if="selectedAnalysisMode == 'Outcome based'"
      fluid
      fill-width
      class="pa-0 ma-0"
    >
      <v-tabs v-model="analyticsTab" light style="margin-top: 2px">
        <v-tab key="analyticsTable"> <span>Statistical Tests</span> </v-tab>
        <v-tab key="forestPlot"> <span>Regression Analysis</span> </v-tab>
      </v-tabs>

      <v-tabs-items v-model="analyticsTab" class="pt-3">
        <v-tab-item key="analyticsTable" :eager="true">
          <analytics-table
            class="ml-1"
            :color-scheme="colorScheme"
            :show-review-help="helpMode && substep == 2.3 && hasFilters"
          />
        </v-tab-item>

        <v-tab-item key="forestPlot" :eager="true">
          <forest-plot
            class="ml-1"
            :color-scheme="colorScheme"
            :show-review-help="helpMode && substep == 2.3 && hasFilters"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>

    <v-container v-else fluid fill-width class="pa-0 ma-0">
      <analytics-table
        class="ml-1"
        :color-scheme="colorScheme"
        :show-review-help="helpMode && substep == 2.3 && hasFilters"
      />
    </v-container>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { actions, state } from '@/store/modules/cohortManager/types';
import AnalyticsTable from '@/components/CohortManager/AnalyticsTable.vue';
import ForestPlot from '@/components/CohortManager/OutcomesAnalysis/ForestPlot.vue';

export default {
  name: 'Analytics',
  components: {
    AnalyticsTable,
    ForestPlot,
  },
  props: {
    colorScheme: {
      type: String,
      required: false,
      default: 'val100',
    },
    showReviewHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
    substep: {
      type: String,
      required: true,
    },
    hasFilters: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      analyticsTab: 0,
    };
  },
  computed: {
    ...mapState('cohortManager', {
      helpMode: state.HELP_MODE,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
      currentAnalyticsTab: state.CURRENT_ANALYTICS_TAB,
    }),
  },
  watch: {
    analyticsTab(tab) {
      if (tab == 1) {
        window.dispatchEvent(new Event('resize'));
      }
      this.setCurrentAnalyticsTab(tab);
    },
  },
  created() {
    // resets state variable
    this.setCurrentAnalyticsTab(this.analyticsTab);
  },
  methods: {
    ...mapActions('cohortManager', {
      setCurrentAnalyticsTab: actions.SET_CURRENT_ANALYTICS_TAB,
    }),
    setAnalyticsTab(t) {
      this.analyticsTab = t;
    },
  },
};
</script>

<style></style>
